module.exports = __webpack_public_path__ + "img/sword.534348cf.svg";